import http, { AUTH_ROUTES } from "../../../../services/api";
import {
  errorNotifier,
  successNotifier,
} from "../../../../components/NotificationHandler";
import { DATA_ROWS } from "../../../../components/CustomTable";
//GET ESTATE DUES HANDLER / LIST OF TENANTS THAT HAVE PAID THEIR ESTATE DUES
export const getEstateDues = async (
  setLoading,
  userId,
  setEstateDues,
  setTotal,
  skip = 0
) => {
  const page = skip * DATA_ROWS.LIMIT;
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_DUES(userId, page));
    console.log(data, ";;");
    return;
    setEstateDues(data.estateDues);
    setTotal && setTotal(data?.totalEstateDues);
    setLoading(false);
  } catch (e) {
    setEstateDues([]);
    setLoading(false);
  }
};

//UPDATE ESTATE DUE AMOUNT
export const addEstateDueAmount = async (setBtnLoading, payload, onClose) => {
  try {
    await http.post(AUTH_ROUTES.POST_ESTATE_DUE, payload);
    setBtnLoading(false);
    successNotifier("Estate due successfully updated");
    onClose();
  } catch (e) {
    errorNotifier(e);
    setBtnLoading(false);
  }
};

//GET CURRENT ESTATE DUE AMOUNT
export const getEstateDue = async (setEstateDue, userId) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));
    setEstateDue(data);
  } catch (e) {
    // errorNotifier(e.response?.data.result);
  }
};

// GET DUE CARDS
export const getDueCards = async (setDueCards, setLoading) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_DUES_CARDS);
    setDueCards(data);
    setLoading(false);
  } catch (e) {
    console.log(e, "error with cards");
    // errorNotifier(e.response?.data.result);
  }
};

// Dues Table
export const getDues = async (
  setLoading,
  userId,
  setDues,
  setTotal,
  skip = 0
) => {
  const page = skip * DATA_ROWS.LIMIT;
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_DUES(page));
    console.log(data, "dues");
    setDues(data);
    setTotal && setTotal(data);
    setLoading(false);
  } catch (e) {
    setDues([]);
    setLoading(false);
  }
};


// Dues Details
export const getDuesDetails = async (setLoading, dueTypeId, setDuesDetails) => {
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_DUES_DETAILS(dueTypeId));
    setDuesDetails(data);
    setLoading(false);
  } catch (e) {
    setDuesDetails([]);
    setLoading(false);
  }
};

// Create Dues
export const createDues = async (setBtnLoading, payload, onClose) => {
  try {
    await http.post(AUTH_ROUTES.CREATE_DUES, payload);
    setBtnLoading(false);
    successNotifier("Estate due successfully created");
    onClose();
  } catch (e) {
    errorNotifier("Error, Please check details and retry");
    // errorNotifier(e?.message || "Error, Please check details and retry");
    setBtnLoading(false);
  }
};
// Edit Dues
export const editDues = async (setBtnLoading, payload, onClose) => {
  try {
    await http.put(AUTH_ROUTES.EDIT_DUES(payload.userId), payload);
    setBtnLoading(false);
    successNotifier("Estate due successfully updated");
    onClose();
  } catch (e) {
    errorNotifier(e?.result?.message);
    setBtnLoading(false);
  }
};
// Delete Dues
export const deleteDues = async (payload, setRefresh, onClose) => {
  try {
    await http.delete(AUTH_ROUTES.DELETE_DUES(payload.deleteId));
    successNotifier("Estate due successfully deleted");
    setRefresh(true);
    onClose();
  } catch (e) {
    // errorNotifier(e?.result?.message);
  }
};
